/**
 * Billing length in days. Prefer BE `days`, else periods * 30.
 * @param {{ days?: number|null, periods?: number|null }|null|undefined} offer
 * @returns {number|null}
 */
const getOfferDays = offer => {
  if (!offer) {
    return null;
  }

  if (typeof offer.days === "number" && !Number.isNaN(offer.days)) {
    return offer.days;
  }

  if (typeof offer.periods === "number" && !Number.isNaN(offer.periods)) {
    return offer.periods * 30;
  }

  return null;
};

export default getOfferDays;
